import { useVisitedVenues } from "../../../hooks/useVisitedVenues";

interface Props { userId: string; }

const CATEGORY_COLORS: Record<string, string> = {
  "Tarihi": "bg-amber-100 text-amber-700",
  "Doğa": "bg-emerald-100 text-emerald-700",
  "Yemek": "bg-red-100 text-red-700",
  "Konaklama": "bg-stone-100 text-stone-600",
  "Eğlence": "bg-orange-100 text-orange-700",
};

export default function VisitedVenuesSection({ userId }: Props) {
  const { venues, loading } = useVisitedVenues(userId);

  if (loading) return <div className="py-12 text-center text-stone-400 text-sm">Yükleniyor...</div>;

  if (venues.length === 0) {
    return (
      <div className="text-center py-16 border border-dashed border-stone-200 rounded-2xl">
        <div className="w-14 h-14 rounded-full bg-stone-100 flex items-center justify-center mx-auto mb-3">
          <i className="ri-map-pin-line text-stone-400 text-2xl" />
        </div>
        <p className="text-stone-700 font-semibold mb-1">Henüz mekan ziyaret edilmedi</p>
        <p className="text-stone-400 text-sm">Rotanı takip ederken durak tamamladığında mekanlar burada görünür.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="font-bold text-stone-900 text-2xl">Ziyaret Ettiklerim</h2>
          <p className="text-stone-500 text-sm mt-1">Gittiğin mekanlar herkese açık olarak görüntülenir.</p>
        </div>
        <span className="bg-emerald-100 text-emerald-700 text-xs font-semibold px-3 py-1.5 rounded-full">{venues.length} mekan</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {venues.map((v) => (
          <div key={v.id} className="bg-white border border-stone-200 rounded-2xl overflow-hidden group hover:-translate-y-0.5 transition-transform">
            <div className="w-full h-36 overflow-hidden">
              <img src={v.image} alt={v.venueName} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div className="p-4">
              <div className="flex items-start justify-between gap-2">
                <h4 className="font-semibold text-stone-900 text-sm leading-snug">{v.venueName}</h4>
                <span className={`flex-shrink-0 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${CATEGORY_COLORS[v.category] ?? "bg-stone-100 text-stone-600"}`}>
                  {v.category}
                </span>
              </div>
              <div className="flex items-center gap-1 mt-2">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-sm" />
                <span className="text-xs text-stone-500">
                  {new Date(v.visitedAt).toLocaleDateString("tr-TR", { year: "numeric", month: "long", day: "numeric" })}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
